import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { GlobalService } from "app/services/global.service";
import { PageService } from "app/services/page-service";
import moment from 'moment';

@Component({
  selector: "app-plan-popup",
  templateUrl: "./plan-popup.component.html",
  styles: [],
})
export class PlanPopupComponent implements OnInit {
  @Input() content: any;
  loader = false;
  appname = "Cruzo";
  subPrice = "1500";
  payAmount = "1700";
  plans: any = [];
  selectPlan = {};
  math = Math;
  billingCycle: any = [];
  selectedPlan: any = {};
  disableBtn = false;
  coupon='';
  couponData :any;
  couponLoader = false;
  constructor(
    public dialogRef: NgbActiveModal,
    public global: GlobalService,
    public service: PageService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.disableBtn = false;
    this.getPackages();
    this.getBillingCycle();
  }
  getPackages() {
    // console.log(this.content.data);
    this.loader = true;
    this.disableBtn = true;
    const params = {
      country_id: this.content.data.country_id,
    };
    if (this.content.data.country_id) {
      params["country_id"] = this.content.data.country_id;
    }
    if (this.content.upgrade) {
      params["upgrade"] = this.content.upgrade;
    }
    this.service.postMethod("aggregator/getPlans", params).then((data) => {
      this.loader = false;
      // this.disableBtn = false
      this.plans = data["data"];
    });
  }
  choosePlan(plan: any) {
    this.disableBtn = false;
    this.selectPlan = {};
    this.selectPlan = plan;
    this.selectPlan["billPrice"] = 0;
    console.log(this.couponData)

    if(!this.content.upgrade){
    if (
      this.selectedPlan &&
      this.selectedPlan["id"] &&
      this.selectedPlan["priceKey"] === "price"
    ) {
      let billPrice = this.selectPlan["current_month_billable_price"] ? this.selectPlan["current_month_billable_price"] : this.selectPlan["price"];
      this.selectPlan['current_month_billable_days'] = this.selectPlan['current_month_billable_days'] ? this.selectPlan['current_month_billable_days'] : 30;
      if (parseInt(this.selectPlan["tax_percent"]) > 0) {
        const taxPer: any = parseFloat(this.selectPlan["tax_percent"]).toFixed(
          2
        );
        if(this.couponData && this.couponData['status'] && this.couponData['value']){
          billPrice = billPrice - (this.couponData['value'] * 1);
          console.log(billPrice);
        }
        this.selectPlan["billPrice"] =
          billPrice * 1 +
          billPrice *
              ((taxPer * 1) / 100)
      } else {
        if(this.couponData && this.couponData['status'] && this.couponData['value']){
          billPrice = billPrice -  (this.couponData['value'] * 1);
        }
        this.selectPlan["billPrice"] = 
          billPrice
          
      }
    } else {
      if (parseInt(this.selectPlan["tax_percent"]) > 0) {
        const taxPer: any = parseFloat(this.selectPlan["tax_percent"]).toFixed(
          2
        );
        console.log(taxPer);
        this.selectPlan["billPrice"] =
          this.selectPlan[this.selectedPlan["priceKey"]] *
          this.selectedPlan["month_count"];
          if(this.couponData && this.couponData['status'] && this.couponData['value']){
            this.selectPlan["billPrice"] = this.selectPlan["billPrice"] -   (this.couponData['value'] * 1);
          }
        const taxPrice = this.selectPlan["billPrice"] * ((taxPer * 1) / 100);
        this.selectPlan["billPrice"] = 
          this.selectPlan["billPrice"] + taxPrice
      } else {
        this.selectPlan["billPrice"] = 
          this.selectPlan[this.selectedPlan["priceKey"]] *
            this.selectedPlan["month_count"]
            if(this.couponData && this.couponData['status'] && this.couponData['value']){
              this.selectPlan["billPrice"] = this.selectPlan["billPrice"] -   (this.couponData['value'] * 1);
            }
      }
      if(this.selectPlan['billPrice'] <=0 ){
        this.disableBtn = true;
      }
    }
  }else{
    this.updateBillPrice();
    // let priceKey = "upgrd_priceWithTax_month";
    // this.selectPlan['current_month_billable_days'] = this.selectPlan['current_month_billable_days'] ? this.selectPlan['current_month_billable_days'] : 30;
    // if(this.content.upgrade){
    // priceKey =
    //     this.selectedPlan["month_count"] === "12"
    //       ? "upgrd_priceWithTax_year"
    //       : this.selectedPlan["month_count"] === "6"
    //       ? "upgrd_priceWithTax_halfyear"
    //       : "upgrd_priceWithTax_month";
    // }
    // let billPrice = this.selectPlan[priceKey]
    // if(this.couponData && this.couponData['status'] && this.couponData['value']){
    //   billPrice = billPrice -  (this.couponData['value'] * 1);
    // }
    // this.selectPlan["billPrice"] = billPrice;
  }
    if(this.selectPlan['billPrice'] <=0 ){
      this.disableBtn = true;
    }
    console.log(this.selectPlan['billPrice']);
  }
  close() {
    this.dialogRef.close({ success: false });
  }
  onSubmit() {
    this.loader = true;
    if(!this.content.upgrade){
      let params = {
          package_id: this.selectPlan["id"],
          billing_cycle_id: this.selectedPlan["id"],
      }
      if(this.coupon && this.couponData && this.couponData['value'] && this.couponData['status']){
        params ["coupon"] =this.coupon;
      }
    this.service
      .postMethod("aggregator/payBill", params)
      .then((data) => {
        const billingResponse = data["data"];
        if (billingResponse && billingResponse["payment_link"]) {
          this.loader = false;
          window.open(billingResponse["payment_link"]);
          this.router.navigate(["/billing"]);
          this.dialogRef.close({ success: true });
        } else {
          if (billingResponse && billingResponse["invoice_link"]) {
            this.global.failureErrorModal(
              "You have already paid for this month...If there are any issues please contact our customer support"
            );
            this.loader = false;
          }
        }
      })
      .catch((err) => {
        console.log(err);
        const errMsg = "Sorry! Please Select any plan";
        this.global.failureErrorModal(errMsg);
        this.loader = false;
      });
    }else{
      let params = {
        package_id: this.selectPlan["id"],
        billing_cycle_id: this.selectedPlan["id"],
      }
      if(this.coupon && this.couponData && this.couponData['value'] && this.couponData['status']){
        params["coupon"] =this.coupon;
      }
      this.service
      .postMethod("aggregator/upgradePlan", params)
      .then((data) => {
        const billingResponse = data["data"];
        if (billingResponse && billingResponse["payment_link"]) {
          this.loader = false;
          window.open(billingResponse["payment_link"]);
          this.router.navigate(["/billing"]);
          this.dialogRef.close({ success: true });
        } else {
          if (billingResponse && billingResponse["invoice_link"]) {
            this.global.failureErrorModal(
              "You have already paid for this month...If there are any issues please contact our customer support"
            );
          }
        }
      });
    }
  }

  getBillingCycle() {
    this.loader = true;
    this.service.getMethod("aggregator/getBillingCycle").then((data) => {
      this.billingCycle = data["data"];
      // if(this.content.data.billing_cycle_id && this.content.data.lead_type_id != '1'){
      //   this.billingCycle = this.billingCycle.filter((obj) => parseInt(obj['id']) >= parseInt(this.content.data.billing_cycle_id))
      // }
      if(this.billingCycle && this.billingCycle.length > 0){
      this.selectedTab(this.billingCycle[0]);
      }
      console.log(this.billingCycle);
    });
  }
  selectedTab(plan: any) {
    this.couponData = {};
    this.coupon = '';
    this.selectPlan = {};
    this.selectedPlan = JSON.parse(JSON.stringify(plan));
    // console.log(this.selectedPlan);
    if (this.selectedPlan && this.selectedPlan["id"]) {
      // console.log(this.selectedPlan, this.selectedPlan["id"]);
      this.selectedPlan["priceKey"] =
        this.selectedPlan["month_count"] === "12"
          ? "price_pm_yearly"
          : this.selectedPlan["month_count"] === "6"
          ? "price_pm_halfyearly"
          : "price";
      // console.log(this.selectedPlan["priceKey"]);
      this.selectedPlan["nextBillKey"] =
        this.selectedPlan["month_count"] === "12"
          ? "next_bill_date_yearly"
          : this.selectedPlan["month_count"] === "6"
          ? "next_bill_date_halfyearly"
          : "next_bill_date";
          this.selectedPlan["upgradable"] =
          this.selectedPlan["month_count"] === "12"
            ? "is_upgradable_yearly"
            : this.selectedPlan["month_count"] === "6"
            ? "is_upgradable_halfyearly"
            : "is_upgradable_monthly";
      // console.log(this.selectedPlan["nextBillKey"]);
    }
    console.log(this.selectedPlan);
  }
  applyCoupon(){
    if(this.coupon && this.coupon.trim().length > 0){
      this.couponLoader = true;
    this.service.postMethod("aggregator/getCouponDetails", {
      coupon_code : this.coupon.trim()
    }).then((data) => {
      console.log(data);
      this.couponData = data["data"];
      if(!this.content.upgrade){
        this.couponLoader = false;
        this.choosePlan(this.selectPlan);
      }else{
        this.updateBillPrice();
        this.couponLoader = false;
      }
    }).catch(err => {
      console.log(err);
      this.couponData = {
        status : 0,
        value : 0
      };
      this.couponLoader = false;
    });
  }
  }
  updateBillPrice(){
    const currentMonthDays = moment(new Date()).daysInMonth();
    let getBillableDays = this.selectPlan['current_month_billable_days'];
    let billPrice = this.selectPlan['price'];
    let basePrice = 0;
    if(this.selectedPlan["priceKey"] === "price"){
     billPrice = this.selectPlan['price'];
     basePrice = this.selectPlan['price']/currentMonthDays * getBillableDays
    }else{
      billPrice = this.selectPlan[this.selectedPlan['priceKey']];
      basePrice = this.selectPlan[this.selectedPlan['priceKey']] * this.selectedPlan['month_count'];
    }
    const balance_money = this.content.data.balance_money ? this.content.data.balance_money : 0;
    let balance_amount = basePrice - balance_money;
    const taxPer: any = parseFloat(this.selectPlan["tax_percent"]).toFixed(
      2
    );
    if(this.couponData && this.couponData['status'] && this.couponData['value']){
      balance_amount = balance_amount - (this.couponData['value'] * 1);
    }
    const balance_amount_tax =  balance_amount * ((taxPer * 1) / 100);

    const total_amount = balance_amount * 1 + balance_amount_tax * 1;
    this.selectPlan['billPrice'] = total_amount;
    if(total_amount < 0){
      this.disableBtn = true;
    }else{
      this.disableBtn = false;
    }
  }
  cancelCoupon(){
    this.couponData = {};
    this.coupon = '';
    this.choosePlan(this.selectPlan);
  }
}
